
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./App.tsx";
import "./index.css";

const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

if (!RECAPTCHA_SITE_KEY) {
  throw new Error("Missing required environment variable: VITE_RECAPTCHA_SITE_KEY");
}

const container = document.getElementById("root")!;

const tree = (
  <HelmetProvider>
    <GoogleReCaptchaProvider
      reCaptchaKey={RECAPTCHA_SITE_KEY}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
    >
      <App />
    </GoogleReCaptchaProvider>
  </HelmetProvider>
);

// A production build ships the page already rendered into #root (see
// scripts/prerender.mjs), so React attaches to that markup instead of throwing
// it away. `vite dev` serves an empty container and takes the other branch.
if (container.hasChildNodes()) {
  hydrateRoot(container, tree);
} else {
  createRoot(container).render(tree);
}
